module.exports = __webpack_public_path__ + "static/media/blog6_big.df37f49e.webp";